import { ProcessRoleOutputDTO } from "../processRole/types";
import { AssetTypeOutputDTO } from "../assetType/types";

export enum PhaseFormFieldType {
  ASSET = "ASSET",
  ROLE = "ROLE",
  PERSON = "PERSON",
  DATE = "DATE",
  TEXT = "TEXT",
  SELECT = "SELECT",
  MONEY = "MONEY",
  NUMBER = "NUMBER",
  STRING = "STRING",
  PAGE = "PAGE",
  INVOICE = "INVOICE",
  UPLOAD = "UPLOAD",
  BINDING_QUESTION = "BINDING_QUESTION",
}

export const PhaseFormFieldTypeLabels: Record<PhaseFormFieldType, string> = {
  [PhaseFormFieldType.ASSET]: "Bem",
  [PhaseFormFieldType.ROLE]: "Personagem",
  [PhaseFormFieldType.PERSON]: "Pessoa",
  [PhaseFormFieldType.DATE]: "Data",
  [PhaseFormFieldType.TEXT]: "Texto Longo",
  [PhaseFormFieldType.SELECT]: "Seleção",
  [PhaseFormFieldType.MONEY]: "Valor Monetário",
  [PhaseFormFieldType.NUMBER]: "Número",
  [PhaseFormFieldType.STRING]: "Texto Curto",
  [PhaseFormFieldType.PAGE]: "Página Informativa",
  [PhaseFormFieldType.INVOICE]: "Notas Fiscais",
  [PhaseFormFieldType.UPLOAD]: "Upload de Arquivos",
  [PhaseFormFieldType.BINDING_QUESTION]: "Pergunta vinculativa",
};

export type PhaseFormFieldOption = {
  value: string;
  key?: string;
};

export enum SubprocessStatus {
  PENDING = "PENDING",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
}

export const SubprocessStatusLabels: Record<SubprocessStatus, string> = {
  [SubprocessStatus.PENDING]: "Pendente",
  [SubprocessStatus.IN_PROGRESS]: "Em Andamento",
  [SubprocessStatus.COMPLETED]: "Concluído",
  [SubprocessStatus.CANCELLED]: "Cancelado",
};

export type SubprocessActivity = {
  id: string;
  name: string;
  status: SubprocessStatus;
  order: number;
  completedAt?: Date;
  startedAt?: Date;
};

export type Subprocess = {
  id: string;
  phaseId: string;
  name: string;
  isTemplate: boolean;
  sourceValue?: string;
  sourceFieldId?: string;
  status: SubprocessStatus;
  activities: SubprocessActivity[];
  progress: number;
  createdAt: Date;
  updatedAt: Date;
};

export type PhaseFormFieldData = {
  _id: string;
  name: string;
  multiline?: boolean;
  canGenerateSubprocess?: boolean;
  type: PhaseFormFieldType;
  text?: string;
  description?: string;
  videoUrl?: string;
  processRole?: ProcessRoleOutputDTO;
  assetType?: AssetTypeOutputDTO;
  options?: PhaseFormFieldOption[];
  acceptFiles?: boolean;
  files?: string[];
  tag?: string;
  required?: boolean;
  mask?: string;
  isPassword?: boolean;
};

export type PhaseFormOutputDTO = {
  _id?: string;
  name?: string;
  description?: string;
  title?: string;
  subtitle?: string;
  short_description?: string;
  formFields?: PhaseFormFieldData[];
  subprocesses?: Subprocess[];
  type?: string;
  format?: string;
  hasAppointment?: boolean;
  appointmentId?: string;
  createdAt?: Date;
  updatedAt?: Date;
};

export enum PhaseFormType {
  OPENED = "OPENED",
  CLOSED = "CLOSED",
}

export const PhaseFormTypeLabels: Record<PhaseFormType, string> = {
  [PhaseFormType.OPENED]: "Aberto",
  [PhaseFormType.CLOSED]: "Fechado",
};

export enum PhaseFormFormat {
  SHORT = "SHORT",
  LONG = "LONG",
}

export const PhaseFormFormatLabels: Record<PhaseFormFormat, string> = {
  [PhaseFormFormat.SHORT]: "Simplificado",
  [PhaseFormFormat.LONG]: "Completo",
};
